import { toastr } from 'react-redux-toastr';
import i18n from '../i18n';

const notify = (title, desc) => {
  toastr.success(i18n.t(title), i18n.t(desc));
};

export default notify;
